import api from '@services'
import { stripEmptyObjects } from '@utils'

const serviceBaseUrl = process.env.REACT_APP_VEHICLE_BASE_URL ?? ''
const servicePrefix = `${serviceBaseUrl}/svc/vehicle/api/vehicle-freezes`

const checkLatestVehicleFreeze = async (vehicleId) => {
  try {
    const response = await api.get(`${servicePrefix}/vehicle/${vehicleId}`)
    return response.data
  } catch (err) {
    console.error(err)
    return null
  }
}

const createVehicleFreeze = async (data) => {
  const response = await api.post(servicePrefix, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}

const getAllVehicleFreezes = async (params) => {
  try {
    const response = await api.get(servicePrefix, { params: stripEmptyObjects(params) })
    return response.data
  } catch (err) {
    console.error(err)
    return { data: [], meta: { pageCount: 1, itemCount: 0 } }
  }
}

const getSingleVehicleFreeze = async (id) => {
  try {
    const response = await api.get(`${servicePrefix}/${id}`)
    return response.data
  } catch (err) {
    console.error(err)
    return null
  }
}

const updateVehicleFreeze = async (id, data) => {
  try {
    const response = await api.patch(`${servicePrefix}/${id}`, data)
    return response.data
  } catch (err) {
    console.error(err)
    return null
  }
}

const deleteVehicleFreeze = async (id) => {
  try {
    const response = await api.delete(`${servicePrefix}/${id}`)
    return response.data
  } catch (err) {
    console.error(err)
    return null
  }
}

const VehicleFreeze = {
  checkLatestVehicleFreeze,
  createVehicleFreeze,
  getAllVehicleFreezes,
  getSingleVehicleFreeze,
  updateVehicleFreeze,
  deleteVehicleFreeze
}

export default VehicleFreeze
